export default __webpack_public_path__ + "static/media/BG-LightBlue-0005.a5297b72.png";